export const state = {
  salaire: undefined,
  salaires: [],
  soussalaire: undefined,
  soussalaires: []
}